var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import { Tabs, Tab } from "../../../components/tabs";
import Flex from "../../../components/templates/flex";
import { Text } from "../../../components/typography";
import { getColor } from "../../../theme";
var Link = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n\n  &:hover,\n  &:visited {\n    color: ", ";\n  }\n"], ["\n  text-decoration: none;\n\n  &:hover,\n  &:visited {\n    color: ", ";\n  }\n"])), getColor("primary"));
var Section = function (_a) {
    var title = _a.title, description = _a.description, url = _a.url;
    return (React.createElement(Flex, { gap: 2, column: true },
        React.createElement(Text, { strong: true, dangerouslySetInnerHTML: {
                __html: (title === null || title === void 0 ? void 0 : title.snippet) || (title === null || title === void 0 ? void 0 : title.raw) || "Untitled",
            } }),
        !!description && (React.createElement(Text, { dangerouslySetInnerHTML: {
                __html: ((description === null || description === void 0 ? void 0 : description.snippet) || (description === null || description === void 0 ? void 0 : description.raw) || "No description") + "&hellip;",
            } })),
        React.createElement(Flex, { alignSelf: "end" },
            React.createElement(Text, { as: Link, color: "primary", href: url, target: "_blank" }, "Read \u2192"))));
};
var Container = function (props) { return (React.createElement(Flex, __assign({ overflow: { vertical: "auto" }, padding: [6, 4], gap: 6, column: true }, props))); };
var StyledTabs = styled(Tabs)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n\n  .tabs > * {\n    min-width: 160px;\n    max-width: 100%;\n  }\n"], ["\n  width: 100%;\n\n  .tabs > * {\n    min-width: 160px;\n    max-width: 100%;\n  }\n"])));
var keys = [
    "learn",
    // "github-cloud",
    // "github-agent",
    "community",
];
var tabValuesByKey = {
    learn: "learn.netdata",
    community: "discourse",
    "github-cloud": "netdata-cloud",
    "github-agent": "netdata",
};
var tabNameByKey = {
    learn: "Documentation",
    community: "Community",
    "github-cloud": "Github / Cloud",
    "github-agent": "Github / Agent",
};
var SearchResults = function (_a) {
    var results = _a.results;
    return (React.createElement(Flex, { overflow: { vertical: "auto" }, "data-testid": "searchResults", flex: true, width: "1000px", height: "60vh" },
        React.createElement(StyledTabs, null, keys.map(function (key) {
            var tabResults = results[tabValuesByKey[key]];
            var tabResultsCount = tabResults === null || tabResults === void 0 ? void 0 : tabResults.length;
            return (React.createElement(Tab, { key: key, label: "" + tabNameByKey[key] + (tabResultsCount ? "  (" + tabResultsCount + ")" : "") },
                React.createElement(Container, null, !tabResultsCount ? (React.createElement(Flex, { padding: [4] },
                    React.createElement(Text, { strong: true }, "No results"))) : (tabResults.map(function (result) {
                    var id = result.id, url = result.url, title = result.title, description = result.description;
                    return (React.createElement(Section, { key: id.raw, url: url.raw, title: title, description: description }));
                })))));
        }))));
};
export default SearchResults;
var templateObject_1, templateObject_2;
